module.exports = __webpack_public_path__ + "img/app2.4f489135.png";